if (!window.Eurus.loadedScript.includes('product-recommendations.js')) {
  window.Eurus.loadedScript.push('product-recommendations.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecommendations', {
        loading: false,
        listOfUpsellProducts: [],
        el: '',
        listUpsellId: [],
        productCount: 0,
        async loadUpsell(el, url, listId, limit, maxItems) {
          this.el = el;
          this.loading = true;
          this.listOfUpsellProducts = [];
          this.productCount = 0;
          this.listUpsellId = [];         
          for (let i = 0; i < listId.length; i++) {
            if (this.productCount >= maxItems) {
              break;
            }    
            try {
              const response = await fetch(`${url}&product_id=${listId[i]}&limit=${limit}&intent=related`);
              const text = await response.text();
              const html = document.createElement('div');
              html.innerHTML = text;
              const des = document.querySelector('.cart-upsell-carousel');
              const src = html.querySelector('.cart-upsell-carousel')
              if(src && des) des.innerHTML = src.innerHTML
              const recommendations = html.querySelector('.product-recommendations');
      
              if (recommendations && recommendations.innerHTML.trim().length) {
                const newUpsellProducts = recommendations.querySelectorAll('template[x-teleport="#cart-upsell-drawer"], template[x-teleport="#cart-upsell"]');
                this.listOfUpsellProducts = [...newUpsellProducts, ...this.listOfUpsellProducts];
      
                for (let index = 0; index < this.listOfUpsellProducts.length; index++) {
                  if (this.productCount >= maxItems) {
                    break;
                  }
                  
                  const element = this.listOfUpsellProducts[index];
                  const elementId = new DOMParser().parseFromString(element.innerHTML, 'text/html').querySelector('.hover-text-link, .link-product-variant').id;
                  
                  if (!this.listUpsellId.includes(elementId)) {
                    this.listUpsellId.push(elementId);
                    el.appendChild(element);
                    this.productCount++;
                    
                    // Reinitialize Reviews.io for upsell element
                    requestAnimationFrame(() => {
                      this.reinitializeReviewsIO(el);
                    });
                  }
                }
      
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0';
                }
              } else if (recommendations && recommendations.classList.contains('main-product')) {
                recommendations.classList.add("hidden");
                el.innerHTML = recommendations.innerHTML;
              }
            } catch (e) {
              console.error(e);
            } finally {
              this.loading = false;
            }
          }
        },
        reinitializeReviewsIO(container) {
          // Dispatch events that Reviews.io might listen for
          window.dispatchEvent(new CustomEvent('reviewsio:reinit'));
          document.dispatchEvent(new CustomEvent('DOMContentLoaded'));
          
          // Get all Reviews.io widgets in the container
          const widgets = container.querySelectorAll('.ruk_rating_snippet');
          
          if (widgets.length > 0) {
            // Use a single batch operation instead of multiple timeouts
            const widgetElements = Array.from(widgets);
            const reinsertPromises = widgetElements.map(widget => {
              return new Promise(resolve => {
                const parent = widget.parentNode;
                const nextSibling = widget.nextSibling;
                
                // Remove widget
                parent.removeChild(widget);
                
                // Use requestAnimationFrame for efficient DOM manipulation
                requestAnimationFrame(() => {
                  parent.insertBefore(widget, nextSibling);
                  resolve();
                });
              });
            });
            
            // Wait for all widgets to be reinserted, then call Reviews.io functions
            Promise.all(reinsertPromises).then(() => {
              this.callReviewsIOFunctions();
            });
          } else {
            // No widgets found, just call the functions
            this.callReviewsIOFunctions();
          }
        },
        
        callReviewsIOFunctions() {
          // Call all Reviews.io functions in sequence
          if (typeof window.reinitialiseRatingSnippet === 'function') {
            window.reinitialiseRatingSnippet();
          }
          
          if (typeof window.loadReviewsIoRatingSnippets === 'function') {
            window.loadReviewsIoRatingSnippets();
          }
          
          if (typeof window.ratingSnippet === 'function') {
            window.ratingSnippet();
          }
          
          // Restart the Reviews.io observer if it exists
          if (typeof window.ratingSnippetObserver !== 'undefined' && window.ratingSnippetObserver) {
            try {
              window.ratingSnippetObserver.disconnect();
              window.ratingSnippetObserver.observe(document.body, {
                childList: true,
                subtree: true
              });
            } catch (e) {
              // Observer restart failed, ignore
            }
          }
        },
        
        load(el, url) {
          this.loading = true;
          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                requestAnimationFrame(() => {
                  el.innerHTML = recommendations.innerHTML;
                  
                  // Reinitialize Reviews.io after content is loaded
                  this.reinitializeReviewsIO(el);
                });
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0';
                }
              } else if (recommendations.classList.contains('main-product')) {
                recommendations.classList.add("hidden");
                el.innerHTML = recommendations.innerHTML;
              }
            })
            .finally(() => {
              this.loading = false;
            }) 
            .catch(e => {
              console.error(e);
            });
        }
      });      
    });
  });
}